import { FagmoblerPortableText } from '@/components/portableText';
import { MaterializedSeriePage } from '@fagmobler/sanity';
import { useEffect, useState } from 'react';

// We only show serie info in the client, since this is duplicated content we dont want robots to index

export const SerieInfo = ({ serie }: { serie: MaterializedSeriePage }) => {
  const [body, setBody] = useState<MaterializedSeriePage['body'] | null>(null);
  useEffect(() => {
    if (window && serie) {
      setBody(serie.body);
    }
  }, [serie]);

  return body ? <FagmoblerPortableText value={body} forbidNegativeMargins/> : null;
};
